import { IntegrationTarget } from "@kaleidoscope-solutions/engine-wasm"

export const integrationTargetLabels: Record<IntegrationTarget, string> = {
  [IntegrationTarget.ShopifySales]: "Quantity sold and revenue",
  [IntegrationTarget.ShopifyStock]: "Stock and safety stock",
  [IntegrationTarget.ShopifyGoodsInTransit]: "Goods in transit"
}

export const integrationTargetFailedLabels: Record<string | number, string> = {
  [IntegrationTarget.ShopifySales]: "Sales data could not be imported from Shopify",
  [IntegrationTarget.ShopifyStock]: "Stock data could not be imported from Shopify",
  [IntegrationTarget.ShopifyGoodsInTransit]: "Goods in transit data could not be imported from Shopify"
}

export const integrationTargetSuccessLabels: Record<string | number, string> = {
  [IntegrationTarget.ShopifySales]: "Sales data has been imported from Shopify",
  [IntegrationTarget.ShopifyStock]: "Stock data has been imported from Shopify",
  [IntegrationTarget.ShopifyGoodsInTransit]: "Goods in transit data has been imported from Shopify"
}

export const integrationTargetRunningLabels: Record<string | number, string> = {
  [IntegrationTarget.ShopifySales]: "Sales data is being imported, do not close your browser window",
  [IntegrationTarget.ShopifyStock]: "Stock data is being imported, do not close your browser window",
  [IntegrationTarget.ShopifyGoodsInTransit]: "Goods in transit data is being imported, do not close your browser window"
}

export const integrationTargetNoDataLabels: Record<string | number, string> = {
  [IntegrationTarget.ShopifySales]: "No new orders to import",
  [IntegrationTarget.ShopifyStock]: "No stock data to import",
  [IntegrationTarget.ShopifyGoodsInTransit]: "No goods in transit data to import"
}

export type IntegrationLabelKind = "checkboxes" | "failed" | "success" | "running" | "noData"

const integrationLabelMaps: Record<IntegrationLabelKind, Record<string | number, string>> = {
  checkboxes: integrationTargetLabels,
  failed: integrationTargetFailedLabels,
  success: integrationTargetSuccessLabels,
  running: integrationTargetRunningLabels,
  noData: integrationTargetNoDataLabels,
}

// Generic label resolver covering all label kinds to avoid multiple duplicated functions.
export function integrationTargetLabel(
  target: IntegrationTarget,
  kind: IntegrationLabelKind
): string {
  const map = integrationLabelMaps[kind]
  return map[target]
}
